export function getExerciseResultsBlocks(block) {
  return block.filter(b => b.showInResults);
}
